
import ClipboardClose from "../../../assets/filled/ClipboardClose.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ClipboardCloseIcon({ className, dataTestid = "ClipboardCloseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ClipboardClose data-testid={dataTestid} className={classes} {...rest} />
  );
}
